import styled from 'styled-components';

export const SectionTitle = styled.h2`
  display: flex;
  align-items: baseline;
  font-size: 16px;
  font-weight: ${(props) => props.theme.fontWeight.bold};
  margin: 0;
`;

export const SubscriptionModalContainer = styled.div<{ variant?: 'regular' | 'large' }>`
  display: flex;
  flex-direction: column;
  width: ${({ variant }) => (variant === 'large' ? 580 : 480)}px;
`;

export const SubscriptionModalContent = styled.div`
  display: flex;
  gap: 16px;
  align-items: flex-start;
`;

export const SubscriptionModalTitle = styled.p`
  font-size: 18px;
  line-height: 1.5;
  font-weight: ${({ theme }) => theme.fontWeight.medium};
  margin: 0;
`;

export const SubscriptionModalDetails = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
  flex: 1;
`;

export const SubscriptionModalFooter = styled.div`
  display: flex;
  padding-top: 24px;
  border-top: 1px solid ${({ theme }) => theme.colors.border.medium};
  margin-top: 40px;
  gap: 4px;
  justify-content: flex-end;
`;

export const ErrorMessage = styled.p`
  color: ${({ theme }) => theme.colors.status.failure};
  margin: 0;
`;
